import { ThemeInput } from "./tokens";

export default {
  dark: false,
  colors: {
    "primary": "#FF3200",
    "on-primary": "#ffffff",
    "secondary": "#FF3200",
    "on-secondary": "#ffffff",
    "error": "#FF5252",
    "on-error": "#ffffff",
    "background": "#ededed",
    "on-background": "#000000",
    "surface": "#eeeeee",
    "on-surface": "#494949",
    "info": "#2196F3",
    "on-info": "#ffffff",
    "success": "#4CAF50",
    "on-success": "#ffffff",
    "warning": "#FB8C00",
    "on-warning": "#ffffff",
    // Custom colors
    "dark-background": "#1A1A1A",
    "on-dark-background": "#dcdcdc",
    "content-background": "#F8F8F8",
    "on-content-background": "#000000",
    "stripes-background": "#1A1A1A",
    "on-stripes-background": "#dcdcdc",
    "footer-background": "#4d4d4d",
  },
  variables: {},
} satisfies ThemeInput;
